// extracted by mini-css-extract-plugin
export default {"wrapperInner":"wrapperInner--R4aLQ","root":"root--qOZeo","collapseContainer":"collapseContainer--k1PHF","noteWrapper":"noteWrapper--RcguK"};